import { combineReducers } from "@reduxjs/toolkit";
import { sidebarReducer } from "./slices";

const layoutReducer = combineReducers({
  sidebar: sidebarReducer,
});

export default layoutReducer;
